/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetReportTab200ResponseBillsInner } from './GetReportTab200ResponseBillsInner';
import {
    GetReportTab200ResponseBillsInnerFromJSON,
    GetReportTab200ResponseBillsInnerFromJSONTyped,
    GetReportTab200ResponseBillsInnerToJSON,
    GetReportTab200ResponseBillsInnerToJSONTyped,
} from './GetReportTab200ResponseBillsInner';
import type { GetReportTab200ResponseProductsInner } from './GetReportTab200ResponseProductsInner';
import {
    GetReportTab200ResponseProductsInnerFromJSON,
    GetReportTab200ResponseProductsInnerFromJSONTyped,
    GetReportTab200ResponseProductsInnerToJSON,
    GetReportTab200ResponseProductsInnerToJSONTyped,
} from './GetReportTab200ResponseProductsInner';
import type { GetReportTab200ResponseReservation } from './GetReportTab200ResponseReservation';
import {
    GetReportTab200ResponseReservationFromJSON,
    GetReportTab200ResponseReservationFromJSONTyped,
    GetReportTab200ResponseReservationToJSON,
    GetReportTab200ResponseReservationToJSONTyped,
} from './GetReportTab200ResponseReservation';
import type { GetReportTab200ResponseShipment } from './GetReportTab200ResponseShipment';
import {
    GetReportTab200ResponseShipmentFromJSON,
    GetReportTab200ResponseShipmentFromJSONTyped,
    GetReportTab200ResponseShipmentToJSON,
    GetReportTab200ResponseShipmentToJSONTyped,
} from './GetReportTab200ResponseShipment';
import type { GetReportTab200ResponseExtrasInner } from './GetReportTab200ResponseExtrasInner';
import {
    GetReportTab200ResponseExtrasInnerFromJSON,
    GetReportTab200ResponseExtrasInnerFromJSONTyped,
    GetReportTab200ResponseExtrasInnerToJSON,
    GetReportTab200ResponseExtrasInnerToJSONTyped,
} from './GetReportTab200ResponseExtrasInner';
import type { GetReportTab200ResponseCustomer } from './GetReportTab200ResponseCustomer';
import {
    GetReportTab200ResponseCustomerFromJSON,
    GetReportTab200ResponseCustomerFromJSONTyped,
    GetReportTab200ResponseCustomerToJSON,
    GetReportTab200ResponseCustomerToJSONTyped,
} from './GetReportTab200ResponseCustomer';
import type { GetReportTab200ResponseRating } from './GetReportTab200ResponseRating';
import {
    GetReportTab200ResponseRatingFromJSON,
    GetReportTab200ResponseRatingFromJSONTyped,
    GetReportTab200ResponseRatingToJSON,
    GetReportTab200ResponseRatingToJSONTyped,
} from './GetReportTab200ResponseRating';

/**
 * 
 * @export
 * @interface GetReportTab200Response
 */
export interface GetReportTab200Response {
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200Response
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200Response
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200Response
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200Response
     */
    code?: string;
    /**
     * 
     * @type {Date}
     * @memberof GetReportTab200Response
     */
    creationTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetReportTab200Response
     */
    closeTime?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof GetReportTab200Response
     */
    open: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetReportTab200Response
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200Response
     */
    status: GetReportTab200ResponseStatusEnum;
    /**
     * 
     * @type {GetReportTab200ResponseShipment}
     * @memberof GetReportTab200Response
     */
    shipment?: GetReportTab200ResponseShipment;
    /**
     * 
     * @type {number}
     * @memberof GetReportTab200Response
     */
    refundableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetReportTab200Response
     */
    refundedAmount: number;
    /**
     * 
     * @type {Array<GetReportTab200ResponseProductsInner>}
     * @memberof GetReportTab200Response
     */
    products: Array<GetReportTab200ResponseProductsInner>;
    /**
     * 
     * @type {Array<GetReportTab200ResponseBillsInner>}
     * @memberof GetReportTab200Response
     */
    bills: Array<GetReportTab200ResponseBillsInner>;
    /**
     * 
     * @type {GetReportTab200ResponseRating}
     * @memberof GetReportTab200Response
     */
    rating?: GetReportTab200ResponseRating;
    /**
     * 
     * @type {GetReportTab200ResponseCustomer}
     * @memberof GetReportTab200Response
     */
    customer?: GetReportTab200ResponseCustomer;
    /**
     * 
     * @type {GetReportTab200ResponseReservation}
     * @memberof GetReportTab200Response
     */
    reservation?: GetReportTab200ResponseReservation;
    /**
     * 
     * @type {Array<GetReportTab200ResponseExtrasInner>}
     * @memberof GetReportTab200Response
     */
    extras: Array<GetReportTab200ResponseExtrasInner>;
}


/**
 * @export
 */
export const GetReportTab200ResponseStatusEnum = {
    Incomplete: 'incomplete',
    Pending: 'pending',
    Paid: 'paid',
    Refunded: 'refunded',
    PartiallyRefunded: 'partiallyRefunded'
} as const;
export type GetReportTab200ResponseStatusEnum = typeof GetReportTab200ResponseStatusEnum[keyof typeof GetReportTab200ResponseStatusEnum];


/**
 * Check if a given object implements the GetReportTab200Response interface.
 */
export function instanceOfGetReportTab200Response(value: object): value is GetReportTab200Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('creationTime' in value) || value['creationTime'] === undefined) return false;
    if (!('open' in value) || value['open'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('refundableAmount' in value) || value['refundableAmount'] === undefined) return false;
    if (!('refundedAmount' in value) || value['refundedAmount'] === undefined) return false;
    if (!('products' in value) || value['products'] === undefined) return false;
    if (!('bills' in value) || value['bills'] === undefined) return false;
    if (!('extras' in value) || value['extras'] === undefined) return false;
    return true;
}

export function GetReportTab200ResponseFromJSON(json: any): GetReportTab200Response {
    return GetReportTab200ResponseFromJSONTyped(json, false);
}

export function GetReportTab200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportTab200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'source': json['source'],
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'creationTime': (new Date(json['creationTime'])),
        'closeTime': json['closeTime'] == null ? undefined : (new Date(json['closeTime'])),
        'open': json['open'],
        'amount': json['amount'],
        'status': json['status'],
        'shipment': json['shipment'] == null ? undefined : GetReportTab200ResponseShipmentFromJSON(json['shipment']),
        'refundableAmount': json['refundableAmount'],
        'refundedAmount': json['refundedAmount'],
        'products': ((json['products'] as Array<any>).map(GetReportTab200ResponseProductsInnerFromJSON)),
        'bills': ((json['bills'] as Array<any>).map(GetReportTab200ResponseBillsInnerFromJSON)),
        'rating': json['rating'] == null ? undefined : GetReportTab200ResponseRatingFromJSON(json['rating']),
        'customer': json['customer'] == null ? undefined : GetReportTab200ResponseCustomerFromJSON(json['customer']),
        'reservation': json['reservation'] == null ? undefined : GetReportTab200ResponseReservationFromJSON(json['reservation']),
        'extras': ((json['extras'] as Array<any>).map(GetReportTab200ResponseExtrasInnerFromJSON)),
    };
}

export function GetReportTab200ResponseToJSON(json: any): GetReportTab200Response {
    return GetReportTab200ResponseToJSONTyped(json, false);
}

export function GetReportTab200ResponseToJSONTyped(value?: GetReportTab200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'source': value['source'],
        'name': value['name'],
        'code': value['code'],
        'creationTime': ((value['creationTime']).toISOString()),
        'closeTime': value['closeTime'] == null ? undefined : ((value['closeTime']).toISOString()),
        'open': value['open'],
        'amount': value['amount'],
        'status': value['status'],
        'shipment': GetReportTab200ResponseShipmentToJSON(value['shipment']),
        'refundableAmount': value['refundableAmount'],
        'refundedAmount': value['refundedAmount'],
        'products': ((value['products'] as Array<any>).map(GetReportTab200ResponseProductsInnerToJSON)),
        'bills': ((value['bills'] as Array<any>).map(GetReportTab200ResponseBillsInnerToJSON)),
        'rating': GetReportTab200ResponseRatingToJSON(value['rating']),
        'customer': GetReportTab200ResponseCustomerToJSON(value['customer']),
        'reservation': GetReportTab200ResponseReservationToJSON(value['reservation']),
        'extras': ((value['extras'] as Array<any>).map(GetReportTab200ResponseExtrasInnerToJSON)),
    };
}

